import { motion } from "framer-motion";
import { EASE } from "./motion";

const links = [
  { label: "Manifiesto", href: "#manifiesto", id: "nav-manifiesto-link" },
  { label: "Verticales", href: "#verticales", id: "nav-verticales-link" },
  { label: "Mercados", href: "#mercados", id: "nav-mercados-link" },
  { label: "Historia", href: "#historia", id: "nav-historia-link" },
  { label: "Contacto", href: "#contacto", id: "nav-contacto-link" },
];

const Nav = () => (
  <motion.header
    initial={{ y: -60, opacity: 0 }}
    animate={{ y: 0, opacity: 1 }}
    transition={{ duration: 0.8, ease: EASE, delay: 0.9 }}
    className="fixed top-0 inset-x-0 z-40 bg-white/80 backdrop-blur-xl border-b border-black/5"
    data-testid="main-nav"
  >
    <div className="max-w-[1600px] mx-auto flex items-center justify-between px-6 lg:px-12 h-16">
      <a href="#top" className="font-display font-bold tracking-tighter text-xl" data-testid="nav-logo">
        ROCKY<span className="text-[#DB2777]">.</span>
      </a>
      <nav className="hidden md:flex items-center gap-8">
        {links.map((l) => (
          <a
            key={l.href}
            href={l.href}
            data-testid={l.id}
            className="link-line text-xs uppercase tracking-[0.2em] font-semibold text-black/70 hover:text-black transition-colors duration-300"
          >
            {l.label}
          </a>
        ))}
      </nav>
      <a
        href="mailto:support@rockyltd.com"
        data-testid="nav-cta-button"
        className="text-xs uppercase tracking-[0.2em] font-bold bg-[#0A0A0A] text-white px-5 py-2.5 hover:bg-[#DB2777] transition-colors duration-300"
      >
        Hablemos
      </a>
    </div>
  </motion.header>
);

export default Nav;
